module.exports = __webpack_public_path__ + "img/flags_left.d72ff98b.svg";